module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Area Clienti","pageMetaDescription":"Area Clienti","ReceivedOffers":"Proposte ricevute","Orders":"Ordini"},"en":{"pageTitle":"Client Area","pageMetaDescription":"Client Area","ReceivedOffers":"Received Offers","Orders":"Orders"}}')
  delete Component.options._Ctor
}
